module.exports = __webpack_public_path__ + "static/media/RUS.4912398a.png";